import { NgModule, inject } from '@angular/core';
import { TailwindThemeService } from '@backoffice-frontend/shared/ui-tailwind';
// import { TailwindThemeModule } from '@backoffice-frontend/shared/ui-tailwind';
import type { Scripts } from '@clean-code/models/common';
import tailwindThemeConfig from '../assets/config/tailwind-theme.config.json';
// import { ConfigModule } from '@clean-code/shared/util-config';
import { DashboardModule } from './modules/dashboard/dasboard.module';
import { FormulaModule } from './modules/formula/formula.module';

const ScriptStore: Scripts[] = [
  {
    name: 'katex',
    src: '../assets/scripts/katex/katex@0.16.8.min.js',
  },
];
@NgModule({
  exports: [],
  declarations: [],
  imports: [DashboardModule, FormulaModule],
  providers: [],
})
export class AppModule {
  constructor() {
    // _accountService: AccountService // TODO: for service injection, provide inRoot does not work by refresh // _dateAdapter: DateAdapter<Dayjs>, // _trace: Sentry.TraceService, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    // Localize.Init(dateAdapter);
    const tailwindService = inject(TailwindThemeService);

    tailwindService.loadConfig(tailwindThemeConfig);
  }
}
